module.exports = __webpack_public_path__ + "img/testAnn.ab8d47a4.jpg";